import { cn } from '@/lib/utils';
import { EyeLogo } from '@/components/EyeLogo';
import ServerMenu from './ServerMenu';
import ServerControls from './ServerControls';
import ServerStatus from './ServerStatus';
import ServerSchedule from './ServerSchedule';


type ServerSidebarProps = {
    isSheet?: boolean;
};

export function ServerSidebar({ isSheet }: ServerSidebarProps) {
    return (
        <aside
            className={cn(
                'flex flex-col gap-3 z-10',
                isSheet ? 'px-4 py-6' : 'tx-sidebar hidden lg:flex',
            )}
        >
            {/* Brand header — desktop sidebar only */}
            {!isSheet && (
                <div
                    className="rounded-xl border px-4 py-4 flex flex-col items-center gap-3"
                    style={{
                        background: 'var(--sc-bg-surface)',
                        borderColor: 'var(--sc-border)',
                    }}
                >
                    <div className="w-full flex justify-center" style={{ maxHeight: 72, overflow: 'hidden' }}>
                        <EyeLogo />
                    </div>
                    <div className="text-center">
                        <div
                            className="text-[11px] font-black tracking-[0.22em] uppercase"
                            style={{ color: 'var(--sc-cyan)', letterSpacing: '0.22em' }}
                        >
                            SC Labs
                        </div>

                    </div>
                </div>
            )}

            {/* Navigation */}
            <div
                className={cn(!isSheet && 'rounded-xl border', 'overflow-hidden')}
                style={!isSheet ? { background: 'var(--sc-bg-surface)', borderColor: 'var(--sc-border)' } : {}}
            >
                <ServerMenu />
            </div>

            <hr className={isSheet ? 'block' : 'hidden'} />

            {/* Server controls + status */}
            <div
                className={cn(
                    !isSheet && 'rounded-xl border',
                    'flex flex-col gap-4 p-4',
                )}
                style={!isSheet ? { background: 'var(--sc-bg-surface)', borderColor: 'var(--sc-border)' } : {}}
            >
                <ServerControls />
                <ServerStatus />
                <ServerSchedule />
            </div>
        </aside>
    );
}
